import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PortalEvent} from 'src/app/classes/calendar';
import {Answer} from 'src/app/classes/dynamic-form';
import {CalendarService} from 'src/app/services/calendar.service';
import {QuestionService} from 'src/app/services/question.service';
import {AuthenticationService} from '../../services/authentication.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'event-registration-viewer',
  templateUrl: './event-registration-viewer.component.html',
  styles: [`
    .errorMessage {
      color: red;
      font-size: 140%;
      font-weight: 500;
      text-align: center;
      padding-bottom: 1em;
      margin-bottom: 1em;
    }
  `]
})
export class EventRegistrationViewerComponent implements OnInit {


	bAdmin = this.authenticationService.isAdmin();

	bLoading = true;
	event = new PortalEvent();
	answer = new Answer();

	subscription = new Subscription();


	constructor(
		private calendarService: CalendarService,
		private activatedRoute: ActivatedRoute,
		private questionService: QuestionService,
		private authenticationService: AuthenticationService,
	) {}


	ngOnInit() {

		this.subscription.add(

			this.activatedRoute.queryParams.subscribe( params => {
	
				if( !params['eventId'] ) {
					alert('Wrong URL');
					console.log('NO eventId');
					this.bLoading = false;
					return;
				}
				if( !params['userId'] ) {
					alert('Wrong URL');
					console.log('NO USERID');
					this.bLoading = false;
					return;
				}
	
				this.calendarService.getEventFullInfo(params['eventId']).subscribe(event => {
					console.log( 'event', event );
	
					if( !event || !event.categoryId ) {
						this.bLoading = false;
						return;
					}
	
					this.event = event;
	
					const obs = this.bAdmin
						? this.questionService.getAnswer( params['userId'], event.id )
						: this.questionService.getAnswerForVeranstaltung( params['userId'], event.id );
	
					obs.subscribe( answer => {
	
						this.bLoading = false;
						if( !answer ) return;
	
						this.answer = answer;
	
					});
	
				});
	
			})

		);

	}

	onDestroy() {
		this.subscription.unsubscribe();
	}

}

